import React from "react";
import { Input } from "../ui/input";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "../ui/select";

// Campos da entrega (data, endereço, telefone, transportador, observação)
export default function DeliveryFormFields({ value, onChange, drivers = [] }) {
  const set = (patch) => onChange({ ...value, ...patch });
  return (
    <div className="space-y-2" data-testid="delivery-form">
      <div className="grid grid-cols-2 gap-2">
        <div>
          <label className="text-xs font-bold">Data da entrega *</label>
          <Input type="date" value={value.scheduled_date || ""} onChange={(e) => set({ scheduled_date: e.target.value })} data-testid="delivery-date" />
        </div>
        <div>
          <label className="text-xs font-bold">Telefone / WhatsApp do cliente</label>
          <Input value={value.contact_phone || ""} onChange={(e) => set({ contact_phone: e.target.value })} placeholder="(82) 99999-9999" data-testid="delivery-phone" />
        </div>
      </div>
      <div>
        <label className="text-xs font-bold">Endereço de entrega *</label>
        <Input value={value.address || ""} onChange={(e) => set({ address: e.target.value })} placeholder="Rua, número, bairro, cidade" data-testid="delivery-address" />
      </div>
      <div>
        <label className="text-xs font-bold">Transportador</label>
        <Select value={value.driver_user_id || "none"} onValueChange={(v) => set({ driver_user_id: v === "none" ? null : v })}>
          <SelectTrigger data-testid="delivery-driver"><SelectValue placeholder="Selecione" /></SelectTrigger>
          <SelectContent>
            <SelectItem value="none">— Definir depois —</SelectItem>
            {drivers.map((d) => <SelectItem key={d.user_id} value={d.user_id}>{d.name}</SelectItem>)}
          </SelectContent>
        </Select>
        {drivers.length === 0 && <p className="text-[11px] text-gray-600 mt-1">Nenhum transportador. Em Administração, dê a permissão "Entregas - Transportador (Fábrica)" ao usuário.</p>}
      </div>
      <div>
        <label className="text-xs font-bold">Observação</label>
        <Input value={value.notes || ""} onChange={(e) => set({ notes: e.target.value })} placeholder="Ex.: entregar pela manhã, portão azul" data-testid="delivery-notes" />
      </div>
    </div>
  );
}
